import type { LangLocales } from '@/types/lang/locales'

import { getLang, localesMessages } from '@rfc/rfc-components-library/locales'
import { createI18n } from 'vue-i18n'
import { checkpointsEn } from './en/checkpointsEn'
import { detectionsEn } from './en/detectionsEn'
import { devicesEn } from './en/devicesEn'
import { enumEn } from './en/enumEn'
import { eventsEn } from './en/eventsEn'
import { menuEn } from './en/menuEn'
import { partnerEn } from './en/partnerEn'
import { checkpointsFr } from './fr/checkpointsFr'
import { detectionsFr } from './fr/detectionsFr'
import { devicesFr } from './fr/devicesFr'
import { enumFr } from './fr/enumFr'
import { eventsFr } from './fr/eventsFr'
import { menuFr } from './fr/menuFr'
import { partnerFr } from './fr/partnerFr'

export type AvailableLangs<T = string> = Record<string, T>
export const defaultAvailableLangs: AvailableLangs<undefined> = {
    fr: undefined,
    en: undefined
}

export type AvailableLangsType = AvailableLangs<LangLocales>

export const capitalizedAvailableLangs = Object.keys(defaultAvailableLangs).map(
    item => item.charAt(0).toUpperCase() + item.slice(1)
)

const messages: AvailableLangsType = {
    en: {
        ...localesMessages.en,
        checkpoint: checkpointsEn,
        detection: detectionsEn,
        device: devicesEn,
        enum: enumEn,
        event: eventsEn,
        menu: menuEn,
        partner: partnerEn
    },
    fr: {
        ...localesMessages.fr,
        checkpoint: checkpointsFr,
        detection: detectionsFr,
        device: devicesFr,
        enum: enumFr,
        event: eventsFr,
        menu: menuFr,
        partner: partnerFr
    }
}

export const i18n = createI18n({
    allowComposition: true,
    legacy: false,
    locale: getLang() ?? 'en',
    fallbackLocale: 'en',
    globalInjection: true,
    messages
})

export default i18n
